import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from 'api/fetch';

export const fetchCreditToBeApplied = createAsyncThunk(
  'nomad_insurance/credit/fetchCreditToBeApplied',
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(`/credits/to-be-applied`, {
        isSafetyWingApi: true
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/credit',
  initialState: {
    creditToBeApplied: null,
    isLoading: false,
    error: null
  },
  extraReducers: {
    [fetchCreditToBeApplied.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    [fetchCreditToBeApplied.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.creditToBeApplied = payload;
    },
    [fetchCreditToBeApplied.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    }
  }
});

// ================== Actions ================== //
export const actions = slice.actions;
export default slice.reducer;
